import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { LocaleInfoIdSchema } from '../locale/locale.types.js';
import { muscleAnatomyTypes } from './muscle.constants.js';
// ===== ID SCHEMAS =====
const MuscleIdSchema = createIdSchema('muscle');
const MuscleTableSelectSchema = createStrictSchema()({
    id: MuscleIdSchema,
    parentId: MuscleIdSchema.nullable(),
    canonicalName: z.string(),
    anatomyType: z.enum(muscleAnatomyTypes),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const MuscleTranslationTableSelectSchema = createStrictSchema()({
    muscleId: MuscleIdSchema,
    localeId: LocaleInfoIdSchema,
    nameTranslation: z.string(),
    commonNameTranslation: z.string().nullable(),
    descriptionTranslation: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
// Combine data from muscleTable and muscleTranslationTable
const PopulatedMuscleTableSelectSchema = MuscleTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    name: z.string(),
    commonName: z.string().nullable(),
    description: z.string().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const MuscleInfoSchema = PopulatedMuscleTableSelectSchema.extend({
    updatedAt: z.string(),
});
const MuscleInfoIdSchema = MuscleIdSchema;
export { MuscleInfoIdSchema, MuscleInfoSchema, MuscleTableSelectSchema, MuscleTranslationTableSelectSchema, PopulatedMuscleTableSelectSchema, };
//# sourceMappingURL=muscle.types.js.map